// Setup › Integrations › Import at `/c/{slug}/setup/data-import` (IMPORT, HARDEN; core, owners):
// guided Zulip and ClickUp imports (features/import/data-import-screen.tsx). Not `/setup/import`:
// that old URL redirects to the CSV import wizard (`/cadence/import`, c.$slug.legacy.tsx).
import { createRoute } from "@tanstack/react-router";
import { DataImportScreen } from "../features/import/data-import-screen";
import { useCompany } from "../features/use-feature";
import { setupRoute } from "./c.$slug.setup";

export const setupImportRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "data-import",
  component: function DataImport() {
    const { api } = setupImportRoute.useRouteContext();
    return <DataImportScreen api={api} company={useCompany()} />;
  },
});
